import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { isFunction } from 'lodash';

import { useStyles } from '~/assets/styles';
import Button from '~/components/core/Atomic/Buttons/Button';
import Popover from '~/components/ui/atoms/Popover';
import usePopoverState from '~/components/ui/atoms/Popover/usePopoverState';
import { MIXPANEL_EVENTS } from '~/pocs/mixpanel';
import { getTabName } from '~/Utils';

import mixpanel from '../../../components/CmsMain/mixpanel';
import ActionMenuButton from '../../../components/core/ActionMenuButton/ActionMenuButton';
import { EXPORT_TYPES } from '../tableauUtils';

export const TableauExportActions = ({ exportTableauView, isDashboardView = false }) => {
  const { classes } = useStyles();
  const { triggerProps, popoverProps } = usePopoverState();
  const [disabled, setDisabled] = useState(true);

  const onExportClick = (exportTableauView, exportType) => {
    const { parentTab, tabName } = getTabName();

    exportTableauView(exportType);
    mixpanel.track(MIXPANEL_EVENTS.REPORTING_ENTITY_EXPORT_CLICKED, {
      reporting_entity: parentTab,
      tab_name: tabName,
      format: exportType,
    });
  };

  useEffect(() => {
    if (disabled && isFunction(exportTableauView)) {
      setDisabled(false);
    }
  }, [disabled, exportTableauView]);

  const actions = [
    {
      label: 'Export to CSV',
      onClick: () => onExportClick(exportTableauView, EXPORT_TYPES.CSV),
      disabled: isDashboardView,
    },
    {
      label: 'Export to Excel',
      onClick: () => onExportClick(exportTableauView, EXPORT_TYPES.EXCEL),
      disabled: isDashboardView,
    },
    { label: 'Export to PDF', onClick: () => onExportClick(exportTableauView, EXPORT_TYPES.PDF), disabled: false },
  ];

  return (
    <>
      <Button
        className={`${classes.actionButton} ${classes.button}`}
        variant="contained"
        color="primary"
        endIcon={<ExpandMore />}
        disabled={disabled}
        {...triggerProps}
      >
        Actions
      </Button>
      <Popover {...popoverProps} aria-label="Export actions" align="start">
        <div style={{ width: 280 }}>
          {actions
            .filter((action) => !action?.disabled)
            .map(({ label, onClick }, idx) => (
              <Fragment key={idx}>
                <ActionMenuButton label={label} onClick={onClick} />
              </Fragment>
            ))}
        </div>
      </Popover>
    </>
  );
};

TableauExportActions.propTypes = {
  exportTableauView: PropTypes.func,
  isDashboardView: PropTypes.bool,
};
